import "./MagicSlider.scss";
import { useRef } from "react";
import { baseUrl } from "../../../utils/apiData";
import { SoloSlide } from "../../../components";
import { Swiper, SwiperSlide } from "swiper/react";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { motion } from "framer-motion";
import { images } from "../../../utils/images";

const MagicSlider = ({ data }) => {
  return (
    <section className="magic_slide p_t p_b">
      <img
        src={images.densePattern}
        alt="Pattern"
        className="bg_pattern"
        style={{ opacity: "0.1" }}
      />
      <div className="content_wrap">
        <div className="slider_grid">
          <div className="left_slide_slider">
            <SoloSlide
              data={{ images: [data?.image_1, data?.image_2, data?.image_3] }}
              title=""
              para=""
            />
          </div>

          <div className="text_side">
            {data?.name && (
              <h3 className="darkGold">
                {data?.name
                  ?.split("")
                  .map((char, k) => (
                    <motion.span
                      initial={{ translateX: 24, opacity: 0 }}
                      whileInView={{ translateX: 0, opacity: 1 }}
                      transition={{
                        duration: 0.4,
                        ease: "easeInOut",
                        delay: 0.04 * k,
                      }}
                      key={k}
                    >
                      {char}
                    </motion.span>
                  ))
                  .concat("")}
              </h3>
            )}
            <p className="darkGold">{data?.description}</p>
            <div className="h_line"></div>
            <AmenitiesSlider data={data} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MagicSlider;

const AmenitiesSlider = ({ data }) => {
  return (
    <div className="amenities_slider">
      {data?.amenties_all?.map((ele, l) => {
        return (
          <div className="enminity_box" key={ele?._id}>
            <img src={`${baseUrl}/${ele?.image}`} alt="Icon" />
            <p className="darkGold">{ele?.name}</p>
          </div>
        );
      })}
    </div>
  );
};
